import getConfig from 'next/config';
var _getConfig = getConfig(),
  publicRuntimeConfig = _getConfig.publicRuntimeConfig;
export default publicRuntimeConfig;